import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=ff52ab22&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=ff52ab22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff52ab22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff52ab22')) {
      api.createRecord('ff52ab22', component.options)
    } else {
      api.reload('ff52ab22', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=ff52ab22&scoped=true&", function () {
      api.rerender('ff52ab22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yu4VdMr6iiE8/JS/comp/SearchFilterTokens.vue"
export default component.exports